export const NOTIFICATIONS_CREATE_SUBSCRIBABLE = 'NOTIFICATIONS_CREATE_SUBSCRIBABLE'
export const NOTIFICATIONS_REMOVE_SUBSCRIBABLE = 'NOTIFICATIONS_REMOVE_SUBSCRIBABLE'
export const NOTIFICATIONS_CLEAR_SUBSCRIBABLE = 'NOTIFICATIONS_CLEAR_SUBSCRIBABLE'
export const NOTIFICATIONS_GET_SUBSCRIBABLE = 'NOTIFICATIONS_GET_SUBSCRIBABLE'
export const NOTIFICATIONS_SET_SUBSCRIBABLE = 'NOTIFICATIONS_SET_SUBSCRIBABLE'

export const NOTIFICATIONS_GET_SUBSCRIPTIONS = 'NOTIFICATIONS_GET_SUBSCRIPTIONS'
export const NOTIFICATIONS_SET_SUBSCRIPTIONS = 'NOTIFICATIONS_SET_SUBSCRIPTIONS'

export const NOTIFICATIONS_GET_RECENT = 'NOTIFICATIONS_GET_RECENT'
export const NOTIFICATIONS_SET_RECENT = 'NOTIFICATIONS_SET_RECENT'
// A steady-state poll fetched the same notification ids the store already holds,
// so the watcher skipped the Brooklyn content fan-out AND the data write; this
// only clears the transient `processing` flag GET_RECENT set.
export const NOTIFICATIONS_SET_RECENT_UNCHANGED = 'NOTIFICATIONS_SET_RECENT_UNCHANGED'

export const NOTIFICATIONS_CREATE_SUBSCRIBER = 'NOTIFICATIONS_CREATE_SUBSCRIBER'
export const NOTIFICATIONS_REMOVE_SUBSCRIBER = 'NOTIFICATIONS_REMOVE_SUBSCRIBER'
export const NOTIFICATIONS_SET_SUBSCRIBER = 'NOTIFICATIONS_SET_SUBSCRIBER'

export const NOTIFICATIONS_REMOVE_SUBSCRIBER_LIST = 'NOTIFICATIONS_REMOVE_SUBSCRIBER_LIST'

// The bell dropdown's PER-TAB preview lists (CO-768).
//
// ⚠️ Separate from GET_RECENT above, which stays unfiltered and must. The dropdown now shows a
// Content and a Community tab, but the unread dot is still counted off `['recent','data']` — a
// member wants to know whether anything is new, not whether anything is new in the tab they
// happen to have open. Two concerns, two fetches, deliberately.
//
// ⚠️ Also separate from GET_ALL below, which is the `/notifications` PAGE. Sharing those slices
// would make the dropdown and the page fight over the same `p`, so a "Load more" on the page
// would redraw the dropdown and vice versa.
export const NOTIFICATIONS_GET_MENU = 'NOTIFICATIONS_GET_MENU'
export const NOTIFICATIONS_SET_MENU = 'NOTIFICATIONS_SET_MENU'

export const NOTIFICATIONS_GET_ALL = 'NOTIFICATIONS_GET_ALL'
export const NOTIFICATIONS_SET_ALL = 'NOTIFICATIONS_SET_ALL'
export const NOTIFICATIONS_CLEAR_ALL = 'NOTIFICATIONS_CLEAR_ALL'

export const NOTIFICATIONS_UPDATE_RECEIVED = 'NOTIFICATIONS_UPDATE_RECEIVED'
export const NOTIFICATIONS_SET_RECEIVED = 'NOTIFICATIONS_SET_RECEIVED'

export function getSubscribableEntity (payload) {
  return { type: NOTIFICATIONS_GET_SUBSCRIBABLE, payload }
}

export function createSubscribableEntity (payload) {
  return { type: NOTIFICATIONS_CREATE_SUBSCRIBABLE, payload }
}

export function removeSubscribableEntity (payload) {
  return { type: NOTIFICATIONS_REMOVE_SUBSCRIBABLE, payload }
}

export function clearSubscribableEntity (payload) {
  return { type: NOTIFICATIONS_CLEAR_SUBSCRIBABLE, payload }
}

export function createSubscriber (payload) {
  return { type: NOTIFICATIONS_CREATE_SUBSCRIBER, payload }
}

export function removeSubscriber (payload) {
  return { type: NOTIFICATIONS_REMOVE_SUBSCRIBER, payload }
}

export function removeSubscriberList (payload) {
  return { type: NOTIFICATIONS_REMOVE_SUBSCRIBER_LIST, payload }
}

export function setNotificationsReceived (payload) {
  return { type: NOTIFICATIONS_UPDATE_RECEIVED, payload }
}

export function getSubscriptions (payload) {
  return { type: NOTIFICATIONS_GET_SUBSCRIPTIONS, payload }
}

/**
 * Fetch the bell's preview list.
 *
 * ⚠️ Takes no arguments, and must not gain a `category`. See the comment on
 * `getRecentNotifications` in `api-notifications.js`: the badge counted off this list is an
 * unfiltered total (CO-768).
 */
export function getRecentNotifications () {
  return { type: NOTIFICATIONS_GET_RECENT }
}

export function clearNotifications () {
  return { type: NOTIFICATIONS_CLEAR_ALL }
}

/**
 * Fetch one tab's preview list for the bell dropdown.
 *
 * @param payload.category `content` or `community` — which tab is asking (CO-768)
 */
export function getMenuNotifications (payload) {
  return { type: NOTIFICATIONS_GET_MENU, payload }
}

/**
 * Fetch one page of the `/notifications` page's list.
 *
 * @param payload.category `content` or `community` — which tab is asking (CO-768)
 * @param payload.after The previous page's `endCursor`. Present means APPEND, behind the
 *   "Load more" button; absent means the first page, which REPLACES.
 */
export function getNotifications (payload) {
  return { type: NOTIFICATIONS_GET_ALL, payload }
}
